import React from "react";
import clsx from "clsx";

const SvgWarning = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 25 25"
		fill="none"
		className={clsx("fill-warning", className)}
		{...props}
	>
		<circle cx={12.391} cy={12.15} r={12} />
		<path
			d="M12.4 15.29c-.643 0-1.19.528-1.19 1.19 0 .644.528 1.19 1.19 1.19.644 0 1.19-.526 1.19-1.19-.019-.643-.546-1.19-1.19-1.19zM13.668 7.86a1.27 1.27 0 0 0-1.267-1.23c-.703 0-1.268.547-1.288 1.23l.234 5.5v.097c.059.507.508.898 1.034.898.527 0 .956-.39 1.034-.898l.254-5.5v-.098z"
			fill="#fff"
		/>
	</svg>
);

export default SvgWarning;
